import { NextBestActionEnum } from '../../../graphql.generated';

export type ValidNextBestActions = Exclude<
    NextBestActionEnum,
    | NextBestActionEnum.EmailMarketingConsent
    | NextBestActionEnum.UpdateYourSituation
>;

export const isValidNextBestActionConfirmation = (
    actionName: NextBestActionEnum
): actionName is ValidNextBestActions =>
    actionName !== NextBestActionEnum.UpdateYourSituation &&
    actionName !== NextBestActionEnum.EmailMarketingConsent;

const trackingMap: {
    [key in ValidNextBestActions]: string;
} = {
    [NextBestActionEnum.VendorLeadNudge]: 'vendor_lead',
    [NextBestActionEnum.AcquireNewHomeowners]: 'track_home',
    [NextBestActionEnum.AppDownloads]: 'app_download',
    [NextBestActionEnum.ClaimHome]: 'claim_tracked_property_as_home',
    [NextBestActionEnum.ContactableHomeowners]: 'property_insight_consent',
    [NextBestActionEnum.ConvertSavedSearchToAlerts]: 'saved_search_to_alert',
    [NextBestActionEnum.ForSaleEngagement]: 'for_sale',
    [NextBestActionEnum.NewHomeLeads]: 'new_homes',
    [NextBestActionEnum.Remortgage]: 'remortgage'
};

export const mapNextBestActionConfirmationToLabel = (
    nextbestActionName: ValidNextBestActions
) => {
    return trackingMap[nextbestActionName];
};
